// 通用顶部条组件
const topbar = () => import("../../layout/topbar");
// 通用主体顶部组件
const AppHeader_Nav = () => import("../../layout/AppHeader_Navs");
// 通用主体头部组件
const AppHeader_main = () => import("../../layout/AppHeader_main");
// 通用底部组件
const AppFooter = () => import("../../layout/AppFooter");
// 当前路由组件
const RemoteSensingMall = () => import('../../views/RemoteSensingMall/RemoteSensingMall.vue');
const MerchantSettled = () => import('../../views/RemoteSensingMall/MerchantSettled.vue');
const companyInfo = () => import('../../views/RemoteSensingMall/companyInfo.vue');
const shopGoodsList = () => import('../../views/RemoteSensingMall/shopGoodsList.vue');
const companySolution = () => import('../../views/RemoteSensingMall/companySolution.vue');
const shopIndex = () => import('../../views/RemoteSensingMall/shopIndex.vue');
const shopCar = () => import('../../views/RemoteSensingMall/shopCar.vue');
const shopDetail = () => import('../../views/RemoteSensingMall/shopDetail.vue');
// 通用底部组件
const AppFooter_moonSample = () => import("../../layout/AppFooter_moonSample");
export default [{
	path: "/RemoteSensingMall",
	name: "RemoteSensingMall",
	components: {
		topbar: topbar,
		header: AppHeader_main,//AppHeader_Nav 顶部主体样式 || AppHeader_main 头部主体样式
		default: RemoteSensingMall,
		footer: AppFooter,
	}, meta: {
		requireAuth: false, // 需要验证登录状态
	}, props: {
		header: {
			type: '2',//根据不同类型切入组件判断逻辑
		}
	},
}, {
	path: "/MerchantSettled",
	name: "MerchantSettled",
	components: {
		// topbar:topbar,
		header: AppHeader_Nav,
		default: MerchantSettled,
		footer: AppFooter,
	},
	meta: {
		requireAuth: true
	},
	props: {
		header: {
			type: '1'
		}
	},
}, {
	path: "/shopIndex",
	name: "shopIndex",
	components: {
		topbar: topbar,
		header: AppHeader_main,
		default: shopIndex,
		footer: AppFooter,
	},
	meta: {
		requireAuth: false
	},
	props: {
		header: {
			type: '1'
		}
	},
},
// 商品详情 - 旧
{
	path: "/shopDetail",
	name: "shopDetail",
	components: {
		topbar: topbar,
		header: AppHeader_main,
		default: shopDetail,
		footer: AppFooter,
	},
	meta: {
		requireAuth: false
	},
	props: {
		header: {
			type: '1'
		}
	}
},
// 商品详情 - 新
{
	path: "/productDetail/:id",
	name: "productDetail",
	components: {
		topbar: topbar,
		header: AppHeader_main,
		default: () => import('../../views/RemoteSensingMall/commodity/ProductDetail.vue'),
		footer: AppFooter,
	},
	meta: { requireAuth: false },
	props: {
		header: {
			type: '1'
		}
	}
},
{
	path: "/companyInfo",
	name: "companyInfo",
	components: {
		topbar: topbar,
		header: AppHeader_main,
		default: companyInfo,
		footer: AppFooter,
	},
	meta: {
		requireAuth: false
	},
	props: {
		header: {
			type: '1'
		}
	},
}, {
	path: "/shopGoodsList",
	name: "shopGoodsList",
	components: {
		topbar: topbar,
		header: AppHeader_main,
		default: shopGoodsList,
		footer: AppFooter,
	},
	meta: {
		requireAuth: false
	},
	props: {
		header: {
			type: '1'
		}
	},
}, {
	path: "/companySolution",
	name: "companySolution",
	components: {
		topbar: topbar,
		header: AppHeader_main,
		default: companySolution,
		footer: AppFooter,
	},
	meta: {
		requireAuth: false
	},
	props: {
		header: {
			type: '1'
		}
	},
}, {
	path: "/shopCar",
	name: "shopCar",
	components: {
		topbar: topbar,
		header: AppHeader_main,
		default: shopCar,
		footer: AppFooter,
	},
	meta: {
		requireAuth: true
	},
	props: {
		header: {
			type: '1'
		}
	},
},
// 遥感商城下的 各个类型的数据的路由
{
	path: "/mall/data",
	name: "DataMall",
	components: {
		topbar: topbar,
		header: AppHeader_main,
		default: () => import('../../views/RemoteSensingMall/commodity/DataProduct.vue'),
		footer: AppFooter,
	},
	meta: {
		requireAuth: false
	},
	props: {
		header: {
			type: '1'
		}
	}
}, {
	path: "/mall/software",
	name: "SoftwareMall",
	components: {
		topbar: topbar,
		header: AppHeader_main,
		default: () => import('../../views/RemoteSensingMall/commodity/SoftwareProduct.vue'),
		footer: AppFooter,
	},
	meta: {
		requireAuth: false
	},
	props: {
		header: {
			type: '1'
		}
	}
}, {
	path: "/mall/solution",
	name: "SolutionMall",
	components: {
		topbar: topbar,
		header: AppHeader_main,
		default: () => import('../../views/RemoteSensingMall/commodity/IndustrySolution.vue'),
		footer: AppFooter,
	},
	meta: {
		requireAuth: false
	},
	props: {
		header: {
			type: '1'
		}
	}
}, {
	path: "/mall/others",
	name: "OthersMall",
	components: {
		topbar: topbar,
		header: AppHeader_main,
		default: () => import('../../views/RemoteSensingMall/commodity/OtherProduct.vue'),
		footer: AppFooter,
	},
	meta: {
		requireAuth: false
	},
	props: {
		header: {
			type: '1'
		}
	}
}, {
	path: "/mall/moonDATA",
	name: "moonDATA",
	components: {
		header: AppHeader_main,
		default: () => import('../../views/RemoteSensingMall/moonDATA.vue'),
		footer: AppFooter_moonSample,
	},
	meta: {
		requireAuth: false
	},
	props: {
		header: {
			type: '1'
		}
	}
}, {
	path: "/ce5web/searchOrder_hyperSearchData.search",
	name: "moonDATAInfo",
	components: {
		header: AppHeader_main,
		default: () => import('../../views/RemoteSensingMall/moonDATAInfo.vue'),
		footer: AppFooter_moonSample,
	},
	// 可选：禁用路径参数解析，避免 . 被识别为参数分隔符
	pathToRegexpOptions: {
		sensitive: true, // 区分大小写
		strict: true // 严格匹配路径（不忽略末尾的 /）
	}
	// meta: {
	// 	requireAuth: false
	// },
	// props: {
	// 	header: {
	// 		type: '1'
	// 	}
	// }
}, {
	path: "/mall/moonDATAInfo",
	name: "moonDATAInfo",
	components: {
		header: AppHeader_main,
		default: () => import('../../views/RemoteSensingMall/moonDATAInfo.vue'),
		footer: AppFooter_moonSample,
	},
	meta: {
		requireAuth: false
	},
	props: {
		header: {
			type: '1'
		}
	}
}, {
	path: "/mall/MarsDATA",
	name: "MarsDATA",
	components: {
		header: AppHeader_main,
		default: () => import('../../views/RemoteSensingMall/MarsDATA.vue'),
		footer: AppFooter_moonSample,
	},
	meta: {
		requireAuth: false
	},
	props: {
		header: {
			type: '1'
		}
	}
}, {
	path: "/mall/Planet",
	name: "MarsDATAPlanet",
	components: {
		header: AppHeader_main,
		default: () => import('../../views/RemoteSensingMall/MarsDATAPlanet.vue'),
		footer: AppFooter_moonSample,
	},
	meta: {
		requireAuth: false
	},
	props: {
		header: {
			type: '1'
		}
	}
},
{
	path: "/mall/MarsDATAInfo",
	name: "MarsDATAInfo",
	components: {
		header: AppHeader_main,
		default: () => import('../../views/RemoteSensingMall/MarsDATAInfo.vue'),
		footer: AppFooter_moonSample,
	},
	meta: {
		requireAuth: false
	},
	props: {
		header: {
			type: '1'
		}
	}
},
{
	// ?Tianwen2&Orbitaldata
	path: "/mall/PlanetDATAInfo",
	name: "PlanetDATAInfo",
	components: {
		header: AppHeader_main,
		default: () => import('../../views/RemoteSensingMall/PlanetDATAInfo.vue'),
		footer: AppFooter_moonSample,
	},
	meta: {
		requireAuth: false
	},
	props: {
		header: {
			type: '1'
		}
	}
}
]